import * as types from "../constants/actionConstants";

// export function expanderUpdate(parentName, expanderName, expanderObj, templateKey, parentKey = "") {
//     return {
//         type: types.EXPANDER_UPDATE,
//         payload: {parentName: parentName, expanderName: expanderName, expanderObj: expanderObj, templateKey: templateKey, parentKey: parentKey}
//     };
// };

export function expanderPreset(parentName, expanderName, templateKeys, templates, parentKey = "") {
    return {
        type: types.EXPANDER_PRESET,
        payload: {parentName: parentName, expanderName: expanderName, templateKeys: templateKeys, templates: templates, parentKey: parentKey}
    };
}

export function expanderCollapseSelected(parentName, expanderName, templateKey, parentKey = "") {
    return {
        type: types.EXPANDER_EXPAND_OR_COLLAPSE_SELECTED,
        payload: {parentName: parentName, expanderName: expanderName, templateKey: templateKey, parentKey: parentKey}
    };
}

export function expanderCollapseAll(parentName, expanderName, templateKeys, parentKey = "") {
    return {
        type: types.EXPANDER_EXPAND_OR_COLLAPSE_ALL,
        payload: {parentName: parentName, expanderName: expanderName, templateKeys: templateKeys, parentKey: parentKey}
    };
}

export function expanderClear(parentName) {
    return {
        type: types.EXPANDER_CLEAR,
        payload: {parentName: parentName}
    };
}

